import { render } from "./TitleYearLabelForDetail.vue?vue&type=template&id=e77f7554&scoped=true&ts=true"
import script from "./TitleYearLabelForDetail.vue?vue&type=script&lang=ts"
export * from "./TitleYearLabelForDetail.vue?vue&type=script&lang=ts"

import "./TitleYearLabelForDetail.vue?vue&type=style&index=0&id=e77f7554&lang=scss&scoped=true"

import exportComponent from "/var/www/prod_sara2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e77f7554"]])

export default __exports__